import React from 'react'
import InputChatBox from './InputChatBox';
import Navbar from './Navbar';
import NewHistory from './NewHistory';
import { apiClient } from './data/api';
import { HistoryProps } from './interface';
import { useEffect, useRef, useState } from 'react';
// import { signIn, useSession } from 'next-auth/react';
// import AccessDenied from "@/components/access-denied";
import toastMessage from './toast-message';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Loader from './loader';
import { StatusCodes } from 'http-status-codes';
import ACCESS_TOKEN from './data/token';
import historyTitleStub from './data/stubs/history_titles.json'
import { getMsalAccessToken } from 'index';

export default function ConvAIMain({ chatWindowMinimized }: { chatWindowMinimized :boolean}) {
  let [historyID, setHistoryID] = useState<number | string>(-1);
  let [histories, setHistories] = useState<HistoryProps[]>([]);
  // const { status } = useSession();
  const [loading, setLoading] = useState<boolean>(false);

  async function fetchHistory() {
    setLoading(true);
    apiClient
      .get('/conversation/history', {
        headers: {
          Authorization: `Bearer ${await getMsalAccessToken()}`,
        },
      })
      .then(
        response => {
          //  let stub = historyTitleStub;
          //  setHistories(stub.conversation_history);
          setHistories(response.data.conversation_history);
          setLoading(false);
        },
        error => {
          // let stub = historyTitleStub;
          // setHistories(stub.conversation_history);
          setLoading(false);
          if (error.response?.data?.detail) {
            console.log(error.response?.data?.detail);
            if (error.response?.status == StatusCodes.UNAUTHORIZED) {
              // void signIn("azure-ad", undefined, { prompt: "login" });
              console.log('please signin again');
            } else if (error.response?.status != StatusCodes.NOT_FOUND) {
              toastMessage('Failed to fetch the old conversations.');
            }
          }
        }
      );
  }

  let handleHistoryID = (id: number | string) => {
    setHistoryID(id);
    console.log(historyID);
  };

  useEffect(() => {
    // if(historyID !== -1){
    // @ts-ignore
    fetchHistory();
    // }
  }, [historyID]);

  return (
    <div className={`flex flex-col overflow-y-hidden relative`} style={{height:'80vh'}}>
      {loading && <Loader />}

      <Navbar
        handleHistoryID={handleHistoryID}
        histories={histories}
        historyID={historyID}
        chatWindowMinimized={chatWindowMinimized}
      />
      <div className="flex flex-1">
        {!chatWindowMinimized && (
          <NewHistory
            handleHistoryID={handleHistoryID}
            histories={histories}
            historyID={historyID}
            chatWindowMinimized={chatWindowMinimized}
          />
        )}
        <InputChatBox
          historyID={historyID}
          handleHistoryID={handleHistoryID}
          chatWindowMinimized={chatWindowMinimized}
        />
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}


